import React, { useContext } from "react";
import { AuthContext } from "@CONTEXTS";
import { Form, Row, Col, Button, Modal, Spin, message } from "antd";
import { HJCreateProduct } from "@FORMS";
import { createProduct } from "@PRODUCTS";
import { AiFillSave } from "react-icons/ai";

const CreateProductModal = ({ form, onClose, setStep, setSpin, spin }) => {
  const { info } = useContext(AuthContext);
  const handleSave = async (values) => {
    setSpin(true);
    let obj;
    if (info?.desiCalculationMode === "DESI_ONLY") {
      obj = {
        name: values.name,
        code: values.code,
        weight: values.weight,
        desi: values.desi,
      };
    } else {
      obj = {
        name: values.name,
        code: values.code,
        width: values.width,
        length: values.length,
        height: values.height,
        weight: values.weight,
      };
    }

    const response = await createProduct(obj);
    setSpin(false);
    if (response.id) {
      message.success({
        content: "Ürün başarıyla eklendi",
        className: "app-success-message",
      });
      form.resetFields();
      setStep("TABLE");
    }
  };

  return (
    <Modal
      visible
      title="Malzeme/Ürün Kaydet"
      onCancel={onClose}
      width={1350}
      footer={false}
    >
      <Form form={form} layout="vertical">
        <HJCreateProduct form={form} />
        <Row gutter={24}>
          <Col flex={"auto"}>
            <Spin spinning={spin} />
          </Col>
          <Col flex="auto">
            <Button
              style={{ float: "right" }}
              type="danger"
              onClick={() => {
                setStep("TABLE");
                form.resetFields();
              }}
              icon={<AiFillSave />}
            >
              Vazgeç
            </Button>
          </Col>
          <Col flex="none">
            <Button
              style={{ float: "right" }}
              type="primary"
              onClick={() => {
                form.validateFields().then((values) => {
                  handleSave(values);
                });
              }}
              icon={<AiFillSave />}
            >
              Malzeme/Ürün Kaydet
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default CreateProductModal;
